export const convertFileToBase64 = (blob: Blob): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

export const tryConvertToBase64 = async (value: any) => {
  if (value instanceof File || value instanceof Blob) {
    return await convertFileToBase64(value);
  }

  if (typeof value === "string" && value.startsWith("data:")) {
    return value;
  }

  console.warn("❌ Unsupported file format or fake File object:", value);
  return null;
};
